import importLocationsProgressStatusReducer from './reducers';

export default importLocationsProgressStatusReducer;
